import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { CardApi } from 'api';
import type { Card } from 'api/methods/CardApi';

/**
 * [Card] Query key 생성
 * --
 */
export const cardQueryKeys = createQueryKeys('card', {
  getCard: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getCards: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Card] 카드 전체 조회
 * --
 */
export const useGetCards = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: cardQueryKeys.getCards(params).queryKey,
    queryFn: () => CardApi.getCards(params),
    ...options,
  });
  return data;
};

/**
 * [Card] 카드 상세 조회
 * --
 */
export const useGetCard = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: cardQueryKeys.getCard(idx, params).queryKey,
    queryFn: () => CardApi.getCard(idx, params),
  });

  return data;
};

/**
 * [Card] 카드 생성
 * --
 */
export const useCreateCard = (body: Card) => {
  const { mutateAsync: createCard, ...result } = useMutation({
    mutationFn: (variables: Card) => CardApi.createCard(variables),
  });

  return { createCard, ...result };
};

/**
 * [Card] 카드 수정
 * --
 */
export const useUpdateCard = (body: Card) => {
  const { mutateAsync: updateCard, ...result } = useMutation({
    mutationFn: (variables: Card) => CardApi.updateCard(variables),
  });

  return { updateCard, ...result };
};

/**
 * [Card] 카드 삭제
 * --
 */
export const useDeleteCard = (idx: number) => {
  const { mutateAsync: deleteCard, ...result } = useMutation({
    mutationFn: (variables: number) => CardApi.deleteCard(variables),
  });

  return { deleteCard, ...result };
};
